export enum SubscriptionStatusResponseEnum {
  SUBSCRIPTION_VALID = "subscription_valid",
  SUBSCRIPTION_PURGED = "subscription_purged",
  SUBSCRIPTION_PURGE_ERROR = "subscription_purge_error",
  SUBSCRIPTION_NOT_FOUND = "subscription_not_found",
  SUBSCRIPTION_NOT_FOUND_IN_DB = "subscription_not_found_in_db",
  SUBSCRIPTION_CANCELED = "subscription_canceled",
  SUBSCRIPTION_ALREADY_CANCELED = "subscription_already_canceled",
}
